import React, { useState } from "react";
import "./Gpmsfaq.css";

/* ============================================================
   CONTENT  (client ka content – yahin se edit karo)
   ============================================================ */
const FAQ_HEAD = {
  badge: "FAQ",
  title: "Frequently Asked Questions",
};

const FAQS = [
  {
    q: "What is Global Port Management System?",
    a: "GPMS is a Qlik-powered port analytics and decision-support platform enhanced with computer vision and predictive AI capabilities. It consolidates data from existing port systems to support operational monitoring, historical analysis, and proactive decision-making.",
  },
  {
    q: "Can GPMS integrate with Navis and our existing systems?",
    a: "GPMS is designed to integrate with Navis, Container Management Systems, gate management platforms, and other enterprise databases, subject to supported interfaces and authorized access.",
  },
  {
    q: "Does GPMS provide both live and historical dashboards?",
    a: "Yes. GPMS supports live or near-real-time operational dashboards and non-live historical analytics for performance evaluation and planning.",
  },
  {
    q: "What does GPMS Vision do?",
    a: "GPMS Vision uses computer vision and OCR technologies to recognize vehicle registration numbers and container identification numbers, supporting verification and improved operational data capture.",
  },
  {
    q: "How does GPMS predict gate congestion?",
    a: "The predictive module analyzes historical gate traffic patterns and available current operational data to estimate future congestion risks and truck turnaround times.",
  },
  {
    q: "How does Container Dwell Risk Intelligence work?",
    a: "The module analyzes available container information and historical dwell patterns to identify containers with an elevated risk of remaining in the terminal beyond configured dwell thresholds.",
  },
  {
    q: "Does GPMS replace our Terminal Operating System?",
    a: "No. GPMS complements existing Terminal Operating Systems by integrating their data and adding analytical and predictive intelligence.",
  },
];

/* ============================================================
   SECTION
   ============================================================ */
const GPMSFaq = () => {
  const [open, setOpen] = useState(0); // pehla sawal khula rahega; null = sab band

  return (
    <section className="gf">
      <div className="gf__container">
        <header className="gf__head">
          <span className="gf__pill">{FAQ_HEAD.badge}</span>
          <h2 className="gf__title">{FAQ_HEAD.title}</h2>
          <span className="gf__underline" />
        </header>

        <div className="gf__list">
          {FAQS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={item.q} className={`gf__item ${isOpen ? "is-open" : ""}`}>
                <h3 className="gf__q-wrap">
                  <button
                    type="button"
                    className="gf__q"
                    aria-expanded={isOpen}
                    aria-controls={`gf-panel-${i}`}
                    id={`gf-btn-${i}`}
                    onClick={() => setOpen(isOpen ? null : i)}
                  >
                    <span className="gf__num">{String(i + 1).padStart(2, "0")}</span>
                    <span className="gf__q-text">{item.q}</span>
                    <span className="gf__icon" aria-hidden="true" />
                  </button>
                </h3>

                <div
                  id={`gf-panel-${i}`}
                  role="region"
                  aria-labelledby={`gf-btn-${i}`}
                  className="gf__panel"
                >
                  <div className="gf__panel-inner">
                    <p className="gf__a">{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default GPMSFaq;